import React from 'react';
import { Card } from 'antd';

export default function DashboardPage() {
  return (
    <Card title="Dashboard">
      <p>Основная информация и статистика</p>
    </Card>
  );
}